import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../../environments/environment';

export type LoggerContext = Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class LoggerService {
  error(message: string, error?: unknown, context?: LoggerContext): void {
    if (!environment.production) {
      console.error(message, error, context);
      return;
    }

    if (error) {
      const exception: unknown = error instanceof Error ? error : new Error(message);
      Sentry.captureException(exception, {
        extra: { ...context, errorContext: message, originalError: error }
      });
    } else {
      Sentry.captureMessage(message, { level: 'error', extra: context });
    }
  }

  warn(message: string, context?: LoggerContext): void {
    if (!environment.production) {
      console.warn(message, context);
      return;
    }

    Sentry.captureMessage(message, { level: 'warning', extra: context });
  }

  info(message: string, context?: LoggerContext): void {
    if (!environment.production) {
      console.info(message, context);
      return;
    }

    Sentry.addBreadcrumb({
      message,
      level: 'info',
      data: context
    });
  }

  debug(_message: string, _context?: LoggerContext): void {
    // No-op in production (tree-shaken)
    // In dev, intentionally silent to avoid console noise
  }
}
